import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import Layout from "../components/Layout";
import useSeo from "../hooks/useSeo";

const COUNTER_EMAIL = "shillongteermorning4758@gmail.com";

const TeerCounter = () => {
  useSeo(
    "Morning Sunday Teer Counter Contact | Shillong Morning Teer",
    "Morning Teer counter contact information for Shillong Morning Teer — email support for enquiries and corrections."
  );
  return (
  <Layout title="Teer Counter">
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="flex items-center gap-2 mb-2">
        <Phone className="w-6 h-6 text-[#c0873a]" />
        <h1 className="text-xl font-bold text-[#1f2a37]">
          Morning Teer Counter Contact
        </h1>
      </div>
      <p className="text-[#374151] leading-relaxed mb-6">
        For reputed Morning Teer counter information, corrections or any
        enquiry regarding the Shillong Morning Teer session, you can reach us at
        the contact below. We only provide informational support related to{" "}
        <b>Morning Teer</b>.
      </p>

      <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 max-w-md space-y-4">
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-lg bg-[#c0873a22] flex items-center justify-center">
            <Mail className="w-5 h-5 text-[#c0873a]" />
          </span>
          <div>
            <p className="text-xs text-gray-500">Email</p>
            <a
              href={`mailto:${COUNTER_EMAIL}`}
              className="font-medium text-[#2f5d84] hover:underline break-all"
            >
              {COUNTER_EMAIL}
            </a>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-lg bg-[#3aa79a22] flex items-center justify-center">
            <MapPin className="w-5 h-5 text-[#3aa79a]" />
          </span>
          <div>
            <p className="text-xs text-gray-500">Location</p>
            <p className="font-medium text-[#1f2a37]">Shillong, Meghalaya</p>
          </div>
        </div>
      </div>

      <p className="text-xs text-gray-500 italic mt-6">
        Note: This website is informational only. We do not sell tickets, accept
        bets or process any payments. Please play responsibly at licensed
        counters.
      </p>
    </div>
  </Layout>
  );
};

export default TeerCounter;
